import './App.css';
import bg from './bg.svg';
import Order from './orderForm/Order';
import NavBar from './layout/NavBar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
function App() {
  return (
    <div
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        backgroundPosition: 'bottom right',
      }}
    >
      <NavBar />
      <Order />
    </div>
  );
}

export default App;
